// src/components/SmartFlow/WorkflowTemplates.jsx
import React from "react";

const TEMPLATES = [
  {
    id: "lead-welcome",
    name: "Lead Welcome Sequence",
    description: "Automatically welcome new leads with a personalized message and add them to follow-up",
    icon: "👋",
    nodes: [
      {
        id: "trigger-1",
        node_type: "TRIGGER",
        position_x: 100,
        position_y: 50,
        config: { trigger_type: "CRM_LEAD_CREATED" },
        order: 1,
      },
      {
        id: "action-1",
        node_type: "ACTION_CRM",
        position_x: 100,
        position_y: 200,
        config: { action_type: "add_note", details: "New lead welcomed" },
        order: 2,
      },
      {
        id: "delay-1",
        node_type: "DELAY",
        position_x: 100,
        position_y: 350,
        config: { delay_seconds: 3600 },
        order: 3,
      },
      {
        id: "action-2",
        node_type: "ACTION_CRM",
        position_x: 100,
        position_y: 500,
        config: { action_type: "change_stage", details: "Move to Follow-up" },
        order: 4,
      },
      {
        id: "end-1",
        node_type: "END",
        position_x: 100,
        position_y: 650,
        config: {},
        order: 5,
      },
    ],
    edges: [
      { source_node_id: "trigger-1", target_node_id: "action-1", condition: null },
      { source_node_id: "action-1", target_node_id: "delay-1", condition: null },
      { source_node_id: "delay-1", target_node_id: "action-2", condition: null },
      { source_node_id: "action-2", target_node_id: "end-1", condition: null },
    ],
  },
  {
    id: "follow-up-automation",
    name: "Follow-up Automation",
    description: "Check lead status and send follow-up if no response in 24 hours",
    icon: "📞",
    nodes: [
      {
        id: "trigger-1",
        node_type: "TRIGGER",
        position_x: 100,
        position_y: 50,
        config: { trigger_type: "SCHEDULED" },
        order: 1,
      },
      {
        id: "condition-1",
        node_type: "CONDITION",
        position_x: 100,
        position_y: 200,
        config: {
          condition_type: "check_variable",
          variable_name: "last_contact",
          expected_value: "24h_ago",
        },
        order: 2,
      },
      {
        id: "action-true",
        node_type: "ACTION_CRM",
        position_x: 300,
        position_y: 350,
        config: { action_type: "add_note", details: "Follow-up needed" },
        order: 3,
      },
      {
        id: "action-false",
        node_type: "ACTION_CRM",
        position_x: -100,
        position_y: 350,
        config: { action_type: "add_note", details: "No follow-up needed" },
        order: 4,
      },
      {
        id: "end-1",
        node_type: "END",
        position_x: 100,
        position_y: 500,
        config: {},
        order: 5,
      },
    ],
    edges: [
      { source_node_id: "trigger-1", target_node_id: "condition-1", condition: null },
      { source_node_id: "condition-1", target_node_id: "action-true", condition: "if_true" },
      { source_node_id: "condition-1", target_node_id: "action-false", condition: "if_false" },
      { source_node_id: "action-true", target_node_id: "end-1", condition: null },
      { source_node_id: "action-false", target_node_id: "end-1", condition: null },
    ],
  },
  {
    id: "daily-report",
    name: "Daily Report Generation",
    description: "Generate and send daily performance report via API",
    icon: "📊",
    nodes: [
      {
        id: "trigger-1",
        node_type: "TRIGGER",
        position_x: 100,
        position_y: 50,
        config: { trigger_type: "SCHEDULED" },
        order: 1,
      },
      {
        id: "action-1",
        node_type: "ACTION_AUTOMATION",
        position_x: 100,
        position_y: 200,
        config: { automation_id: "daily-metrics-collector" },
        order: 2,
      },
      {
        id: "action-2",
        node_type: "ACTION_API",
        position_x: 100,
        position_y: 350,
        config: { url: "https://api.example.com/reports", method: "POST" },
        order: 3,
      },
      {
        id: "end-1",
        node_type: "END",
        position_x: 100,
        position_y: 500,
        config: {},
        order: 4,
      },
    ],
    edges: [
      { source_node_id: "trigger-1", target_node_id: "action-1", condition: null },
      { source_node_id: "action-1", target_node_id: "action-2", condition: null },
      { source_node_id: "action-2", target_node_id: "end-1", condition: null },
    ],
  },
];

const WorkflowTemplates = ({ onSelectTemplate, onClose }) => {
  const handleUseTemplate = (template) => {
    onSelectTemplate({
      name: template.name,
      description: template.description,
      trigger_type: template.nodes[0]?.config?.trigger_type || "MANUAL",
      nodes: template.nodes,
      edges: template.edges,
    });
    onClose();
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "white",
          borderRadius: "8px",
          width: "90%",
          maxWidth: "800px",
          maxHeight: "80vh",
          overflow: "auto",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            padding: "20px",
            borderBottom: "1px solid #e0e0e0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            position: "sticky",
            top: 0,
            background: "white",
            zIndex: 1,
          }}
        >
          <h2 style={{ margin: 0, fontSize: "18px" }}>Templates de Fluxos Inteligentes</h2>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "24px",
              cursor: "pointer",
              color: "#7f8c8d",
            }}
          >
            ×
          </button>
        </div>

        {/* Templates Grid */}
        <div style={{ padding: "20px" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
              gap: "20px",
            }}
          >
            {TEMPLATES.map((template) => (
              <div
                key={template.id}
                style={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  padding: "20px",
                  cursor: "pointer",
                  transition: "all 0.2s",
                  backgroundColor: "white",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "#3498db";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(52, 152, 219, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "#e0e0e0";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{
                    fontSize: "48px",
                    textAlign: "center",
                    marginBottom: "15px",
                  }}
                >
                  {template.icon}
                </div>
                <h3 style={{ margin: "0 0 10px 0", fontSize: "16px", color: "#2c3e50" }}>
                  {template.name}
                </h3>
                <p style={{ margin: "0 0 15px 0", fontSize: "13px", color: "#7f8c8d", lineHeight: "1.5" }}>
                  {template.description}
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "15px",
                    paddingTop: "15px",
                    borderTop: "1px solid #ecf0f1",
                  }}
                >
                  <span style={{ fontSize: "12px", color: "#95a5a6" }}>
                    {template.nodes.length} nodes
                  </span>
                  <button
                    onClick={() => handleUseTemplate(template)}
                    style={{
                      padding: "6px 14px",
                      background: "#3498db",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: "500",
                    }}
                  >
                    Use Template
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Empty State (if no templates) */}
        {TEMPLATES.length === 0 && (
          <div
            style={{
              padding: "60px 20px",
              textAlign: "center",
              color: "#7f8c8d",
            }}
          >
            <div style={{ fontSize: "48px", marginBottom: "15px" }}>📋</div>
            <p>No templates available yet</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkflowTemplates;
